"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

// Match the example background
const POLY_GREEN = "#154734";
export default function AgendaOverview() {
  const {
    ref: day1Ref,
    isVisible: day1Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: day2Ref,
    isVisible: day2Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const tracks = ["LLM\nSponsored by Radiology Associates", "ML in Healthcare", "Visual and Perceptual AI", "Systems Thinking and AI in Healthcare", "Risk Governance and Ethical Considerations"];
  const day1Schedule = [{
    time: "Room",
    sessions: [{
      content: "192-237",
      track: 0
    }, {
      content: "192-239",
      track: 1
    }, {
      content: "192-240",
      track: 2
    }, {
      content: "192-242",
      track: 3
    }, {
      content: "192-220",
      track: 4
    }],
    isRoomRow: true
  }, {
    time: "9:00 AM",
    sessions: [{
      content: "Conference Welcome - Building 192, Room 220",
      colspan: 5,
      isKeynote: true,
      speaker: "Jill Speece",
      description: "Conference Welcome - Building 192, Room 220"
    }]
  }, {
    time: "10:00 AM",
    sessions: [{
      content: "Research Workshop - AI in Healthcare Curriculum Development Survey Part A - Building 192, Room 220",
      colspan: 5,
      isWorkshop: true,
      speaker: "Ximena Greatorex",
      description: "Research Workshop - AI in Healthcare Curriculum Development Survey Part A - Building 192, Room 220"
    }]
  }, {
    time: "10:30 AM - 11:10 AM",
    sessions: [{
      content: "Borislav Hristov\nFrom Deep Learning to LLMs: The AI Transformation of the Medical Facility\nSM: Carter",
      track: 0,
      isSpeaker: true,
      speaker: "Borislav Hristov",
      description: "From Deep Learning to LLMs: The AI Transformation of the Medical Facility\nSM: Carter"
    }, {
      content: "Alexia Tănăseanu and Dr. Jamie Fairclough\nQuantum Machine Learning\nSM: Matthew",
      track: 1,
      isSpeaker: true,
      speaker: "Alexia Tănăseanu and Dr. Jamie Fairclough",
      description: "Quantum Machine Learning\nSM: Matthew"
    }, {
      content: "",
      track: 2
    }, {
      content: "Geoff Austin (V)\nEconomic Value of AI Uses In Healthcare Operations\nSM: Kait",
      track: 3,
      isSpeaker: true,
      speaker: "Geoff Austin (V)",
      description: "Economic Value of AI Uses In Healthcare Operations\nSM: Kait"
    }, {
      content: "Dr. Carisa Champion (V)\nShaping the Future of AI in Medicine: Voices of Emerging and Established Physician Leaders\nSM: Owen W",
      track: 4,
      isSpeaker: true,
      speaker: "Dr. Carisa Champion (V)",
      description: "Shaping the Future of AI in Medicine: Voices of Emerging and Established Physician Leaders\nSM: Owen W"
    }]
  }, {
    time: "11:15 AM - 11:55 AM",
    sessions: [{
      content: "Dr. Stephen Holtzman\nTurboRad: Creating Medical Reports\nSM: Owen",
      track: 0,
      isSpeaker: true,
      speaker: "Dr. Stephen Holtzman",
      description: "TurboRad: Creating Medical Reports\nSM: Owen"
    }, {
      content: "Dr. David Reinkensmeyer from UC Irvine\nAI in Rehabilitation Robotics\nSM: Jacob",
      track: 1,
      isSpeaker: true,
      speaker: "Dr. David Reinkensmeyer from UC Irvine",
      description: "AI in Rehabilitation Robotics\nSM: Jacob"
    }, {
      content: "Nathan Wong, DDS\nAI in Dentistry\nSM: Camryn Penn",
      track: 2,
      isSpeaker: true,
      speaker: "Nathan Wong, DDS",
      description: "AI in Dentistry\nSM: Camryn Penn"
    }, {
      content: "Dr. Maame Yaa \"Maya\" A. B. Yiadom\nAI Applications in Time Critical Heart Attack Operations\nSM: Kait",
      track: 3,
      isSpeaker: true,
      speaker: "Dr. Maame Yaa \"Maya\" A. B. Yiadom",
      description: "AI Applications in Time Critical Heart Attack Operations\nSM: Kait"
    }, {
      content: "Aaron Poirier\nChallenges of AI in Healthcare: A Practical View from the Front Lines\nSM: Dean",
      track: 4,
      isSpeaker: true,
      speaker: "Aaron Poirier",
      description: "Challenges of AI in Healthcare: A Practical View from the Front Lines\nSM: Dean"
    }]
  }, {
    time: "12:00 PM",
    sessions: [{
      content: "LUNCH",
      colspan: 5,
      isBreak: true
    }]
  }, {
    time: "1:00 PM - 1:55 PM",
    sessions: [{
      content: "Houman Payami (V)\nHow AI is Transforming Root Cause Analysis in Healthcare\nSM: Gabriel",
      track: 0,
      isSpeaker: true,
      speaker: "Houman Payami (V)",
      description: "How AI is Transforming Root Cause Analysis in Healthcare\nSM: Gabriel"
    }, {
      content: "",
      track: 1
    }, {
      content: "Abhishek Moturu (V)\nPediatric cancer detection in whole-body MRIs\nFacial pain detection in older adults with severe dementia\nCorrecting mislabels in imaging datasets while training neural networks\nSM: Harry",
      track: 2,
      isSpeaker: true,
      speaker: "Abhishek Moturu (V)",
      description: "Pediatric cancer detection in whole-body MRIs\nFacial pain detection in older adults with severe dementia\nCorrecting mislabels in imaging datasets while training neural networks\nSM: Harry"
    }, {
      content: "Dr. Jill Speece\nSystems Thinking Principles from Practical Systems Thinking\nSM: Giovanni",
      track: 3,
      isSpeaker: true,
      speaker: "Dr. Jill Speece",
      description: "Systems Thinking Principles from Practical Systems Thinking\nSM: Giovanni"
    }, {
      content: "",
      track: 4
    }]
  }, {
    time: "2:00 PM - 2:55 PM",
    sessions: [{
      content: "Adharsh Rajendran (V)\nLLMs and AI in Medical Tech\nSM: Gabriel",
      track: 0,
      isSpeaker: true,
      speaker: "Adharsh Rajendran (V)",
      description: "LLMs and AI in Medical Tech\nSM: Gabriel"
    }, {
      content: "",
      track: 1
    }, {
      content: "Mahtab Milburn and Dr. Jamie Fairclough\nFrom Pixels to Patients: Perceptual AI Applications in Healthcare\nSM: Rowan",
      track: 2,
      isSpeaker: true,
      speaker: "Mahtab Milburn and Dr. Jamie Fairclough",
      description: "From Pixels to Patients: Perceptual AI Applications in Healthcare\nSM: Rowan"
    }, {
      content: "Dr. Michael D. Whitt\nBiomechanics and Medical Devices\nSM: Gideon",
      track: 3,
      isSpeaker: true,
      speaker: "Dr. Michael D. Whitt",
      description: "Biomechanics and Medical Devices\nSM: Gideon"
    }, {
      content: "Dr. Amitabha Palmer\nUnequivocal Benefit? The Fluffy Ethics of AI in Medical Research\nSM: Sydney",
      track: 4,
      isSpeaker: true,
      speaker: "Dr. Amitabha Palmer",
      description: "Unequivocal Benefit? The Fluffy Ethics of AI in Medical Research\nSM: Sydney"
    }]
  }, {
    time: "3:00 PM - 3:55 PM",
    sessions: [{
      content: "",
      track: 0
    }, {
      content: "",
      track: 1
    }, {
      content: "Miguel Elasmar\nProduct Design for the automation age\nSM: Jake Altieri",
      track: 2,
      isSpeaker: true,
      speaker: "Miguel Elasmar",
      description: "Product Design for the automation age\nSM: Jake Altieri"
    }, {
      content: "Kristen Ho\nAI Project: Strategic Healthcare Planning\nSM: Giovanni",
      track: 3,
      isSpeaker: true,
      speaker: "Kristen Ho",
      description: "AI Project: Strategic Healthcare Planning\nSM: Giovanni"
    }, {
      content: "Keith Abney\nWorkshop on Conceptualizing AI Risk\nSM: Toula",
      track: 4,
      isSpeaker: true,
      speaker: "Keith Abney",
      description: "Workshop on Conceptualizing AI Risk\nSM: Toula"
    }]
  }, {
    time: "4:00 PM - 4:30 PM",
    sessions: [{
      content: "Closing remarks of Day 1 (Recapping)",
      colspan: 5,
      isClosing: true
    }]
  }, {
    time: "5:00 PM - 6:00 PM",
    sessions: [{
      content: "Reception at Woodstock's Pizza - Sponsored by TurboRad",
      colspan: 5,
      isReception: true
    }]
  }];
  const day2Schedule = [{
    time: "Room",
    sessions: [{
      content: "192-237",
      track: 0
    }, {
      content: "192-239",
      track: 1
    }, {
      content: "192-240",
      track: 2
    }, {
      content: "192-242",
      track: 3
    }, {
      content: "192-220",
      track: 4
    }],
    isRoomRow: true
  }, {
    time: "9:00 AM - 9:40 AM",
    sessions: [{
      content: "Networking and Coffee - Sponsored by the Cal Poly IME Department",
      colspan: 5,
      isBreak: true
    }]
  }, {
    time: "9:45 AM - 10:25 AM",
    sessions: [{
      content: "Hari Mudipalli & Dr. Orest Boyko (IP)\nArchitecting Truth: Implementing RAG Systems to Mitigate Hallucinations in Clinical and Academic Support\nSM: Colin",
      track: 0,
      isSpeaker: true,
      speaker: "Hari Mudipalli & Dr. Orest Boyko (IP)",
      description: "Architecting Truth: Implementing RAG Systems to Mitigate Hallucinations in Clinical and Academic Support\nSM: Colin"
    }, {
      content: "Dr. Shreeshan Jena\nPredicting Human Gait Using Machine Learning\nSM: Sophia",
      track: 1,
      isSpeaker: true,
      speaker: "Dr. Shreeshan Jena",
      description: "Predicting Human Gait Using Machine Learning\nSM: Sophia"
    }, {
      content: "Student Research Roundtable Discussion\nSM: Rowan Imlay-Morris",
      track: 2,
      isSpeaker: true,
      speaker: "Student Research Roundtable Discussion",
      description: "SM: Rowan Imlay-Morris"
    }, {
      content: "",
      track: 3
    }, {
      content: "Di Lacey\nThe Jury is Still Out: Pending Litigation on AI in Healthcare",
      track: 4,
      isSpeaker: true,
      speaker: "Di Lacey",
      description: "The Jury is Still Out: Pending Litigation on AI in Healthcare"
    }]
  }, {
    time: "10:30 AM - 11:25 AM",
    sessions: [{
      content: "",
      track: 0
    }, {
      content: "",
      track: 1
    }, {
      content: "Rahul Khot\nVP of AI & Innovation @ Planet DDS\nSM: Jake Altieri/ Mikayla Dunn",
      track: 2,
      isSpeaker: true,
      speaker: "Rahul Khot",
      description: "VP of AI & Innovation @ Planet DDS\nSM: Jake Altieri/ Mikayla Dunn"
    }, {
      content: "Dr. Jamie Fairclough\nFrom Systems Thinking to Systems Engineering: Designing Responsible AI for Healthcare\nSM: Aaron",
      track: 3,
      isSpeaker: true,
      speaker: "Dr. Jamie Fairclough",
      description: "From Systems Thinking to Systems Engineering: Designing Responsible AI for Healthcare\nSM: Aaron"
    }, {
      content: "Di Lacey\nFuture leaders of AI in Healthcare- Student Panel",
      track: 4,
      isSpeaker: true,
      speaker: "Di Lacey",
      description: "Future leaders of AI in Healthcare- Student Panel"
    }]
  }, {
    time: "11:30 AM - 12 PM",
    sessions: [{
      content: "Research Workshop - AI in Healthcare Curriculum Development Survey Part B - Building 192, Room 220",
      colspan: 5,
      isWorkshop: true,
      speaker: "Ximena Greatorex",
      description: "Research Workshop - AI in Healthcare Curriculum Development Survey Part B - Building 192, Room 220"
    }]
  }, {
    time: "12:00 PM - 12:55 PM",
    sessions: [{
      content: "LUNCH",
      colspan: 5,
      isBreak: true
    }]
  }, {
    time: "1:00 PM - 1:40 PM",
    sessions: [{
      content: "Dr. Robert Turbow\nLLMs at the Bedside and for Patient Safety\nSM: Beau",
      track: 0,
      isSpeaker: true,
      speaker: "Dr. Robert Turbow",
      description: "LLMs at the Bedside and for Patient Safety\nSM: Beau"
    }, {
      content: "",
      track: 1
    }, {
      content: "Dr. Juliet Penn\nArtificial Intelligence in Medicine: Augmenting Physicians or Replacing Judgment?\nSM: Camryn Penn",
      track: 2,
      isSpeaker: true,
      speaker: "Dr. Juliet Penn",
      description: "Artificial Intelligence in Medicine: Augmenting Physicians or Replacing Judgment?\nSM: Camryn Penn"
    }, {
      content: "Dr. Ria Kanjilal\nAI Driven Intelligent Healthcare Monitoring\nSM: Leo",
      track: 3,
      isSpeaker: true,
      speaker: "Dr. Ria Kanjilal",
      description: "AI Driven Intelligent Healthcare Monitoring\nSM: Leo"
    }, {
      content: "",
      track: 4
    }]
  }, {
    time: "1:45 PM - 2:25 PM",
    sessions: [{
      content: "AI and Bioethics - A Bedside Perspective - Building 192, Room 220\nSM: Sydney",
      colspan: 5,
      isWorkshop: true,
      speaker: "Dr. Robert Turbow",
      description: "AI and Bioethics - A Bedside Perspective - Building 192, Room 220\nSM: Sydney"
    }]
  }, {
    time: "2:30 PM - 3:25 PM",
    sessions: [{
      content: "Safe Implementation of AI in Clinical Practice: A Case Study Risk Analysis Workshop - Building 192, Room 220",
      colspan: 5,
      isWorkshop: true,
      speaker: "Ximena Greatorex",
      description: "Safe Implementation of AI in Clinical Practice: A Case Study Risk Analysis Workshop - Building 192, Room 220"
    }]
  }, {
    time: "3:30 PM - 4:00 PM",
    sessions: [{
      content: "Closing remarks (20-30 min)",
      colspan: 5,
      isClosing: true
    }]
  }];
  const renderSession = (session: any, index: number, isRoomRow?: boolean) => {
    const baseClasses = "p-3 text-sm border border-white/10 transition-all duration-300 hover:bg-white/5 text-center";
    let typeClasses = "";
    if (isRoomRow) {
      typeClasses = "bg-slate-700/40 font-medium text-foreground";
    } else if (session.isKeynote) {
      typeClasses = "bg-gradient-to-r from-emerald-600/30 to-teal-600/30 font-semibold";
    } else if (session.isWorkshop) {
      typeClasses = "bg-blue-600/20 font-medium";
    } else if (session.isBreak) {
      typeClasses = "bg-amber-600/20 font-medium italic";
    } else if (session.isClosing) {
      typeClasses = "bg-purple-600/20 font-medium";
    } else if (session.isReception) {
      typeClasses = "bg-pink-600/20 font-medium";
    } else if (session.isSpeaker) {
      typeClasses = "bg-emerald-700/30";
    } else {
      typeClasses = "bg-emerald-700/30";
    }
    return <td key={index} colSpan={session.colspan || 1} className={`${baseClasses} ${typeClasses}`}>
        {isRoomRow ? <div className="font-semibold">{session.content}</div> : session.speaker ? <div>
            <div className="sparkle-text font-bold text-base mb-1 text-yellow-300">
              {session.speaker}
            </div>
            {session.description && <div className="text-xs mt-1 text-gray-300 leading-relaxed">
                {session.description.split("\n").map((line: string, i: number) => <div key={i} className={i > 0 ? "mt-1" : ""}>
                    {line}
                  </div>)}
              </div>}
          </div> : session.content.split("\n").map((line: string, i: number) => <div key={i} className={i > 0 ? "text-xs mt-1 text-muted-foreground" : ""}>
              {line}
            </div>)}
      </td>;
  };
  return <>
      <style jsx>{`
        @keyframes sparkle {
          0%, 100% {
            background-position: 0% 50%;
            filter: brightness(1) drop-shadow(0 0 2px rgba(253, 224, 71, 0.5));
          }
          50% {
            background-position: 100% 50%;
            filter: brightness(1.3) drop-shadow(0 0 8px rgba(253, 224, 71, 0.8));
          }
        }

        .sparkle-text {
          background: linear-gradient(
            90deg,
            #fde047 0%,
            #fbbf24 25%,
            #fde047 50%,
            #fbbf24 75%,
            #fde047 100%
          );
          background-size: 200% auto;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: sparkle 3s ease-in-out infinite;
          text-shadow: 0 0 10px rgba(253, 224, 71, 0.3);
        }
      `}</style>

      <section id="agenda-overview" className="relative py-16 px-6 overflow-hidden md:px-12" style={{
      backgroundColor: POLY_GREEN
    }}>
        {/* Subtle background pattern */}
        <div className="absolute inset-0 opacity-5 pointer-events-none">
          <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff_1px,transparent_1px),linear-gradient(to_bottom,#ffffff_1px,transparent_1px)] bg-[size:4rem_4rem]" />
        </div>

        <div className="max-w-7xl mx-auto space-y-12 relative">
          <div className="text-center mb-12">
            <h1 className="text-5xl font-bold mb-4 !font-serif !text-[hsl(42,82%,41%)] md:text-6xl">
              AI Conference Schedule
            </h1>
            <p className="text-muted-foreground text-lg mb-2">
              *Specific Speaker Scheduling will be filled out as they come in
            </p>
            <p className="text-muted-foreground text-sm">
              SM = Student Moderator | (V) = Virtual Session
            </p>
          </div>

          {/* Day 1 */}
          <div ref={day1Ref} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${day1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h2 className="text-4xl font-bold mb-8 !text-[hsl(42,82%,41%)] !italic md:text-5xl">
              Saturday, March 14th
            </h2>

            <div className="overflow-x-auto rounded-lg shadow-2xl">
              <table className="w-full border-collapse min-w-[800px]">
                <thead>
                  <tr className="bg-emerald-800/50">
                    <th className="p-4 text-center font-bold text-foreground border border-white/20 w-40">
                      Time
                    </th>
                    {tracks.map((track, i) => <th key={i} className="p-4 text-center font-bold text-foreground border border-white/20">
                        {track.split("\n").map((line: string, lineIndex: number) => <div key={lineIndex} className={lineIndex > 0 ? "text-xs mt-1 text-red-300 font-normal" : ""}>
                            {line}
                          </div>)}
                      </th>)}
                  </tr>
                </thead>
                <tbody>
                  {day1Schedule.map((slot, i) => <tr key={i} className="hover:bg-white/5 transition-colors">
                      <td className="p-4 font-semibold text-foreground border border-white/10 whitespace-nowrap text-center">
                        {slot.time}
                      </td>
                      {slot.sessions.length === 1 && slot.sessions[0].colspan ? renderSession(slot.sessions[0], 0, slot.isRoomRow) : tracks.map((_, trackIndex) => {
                    const session = slot.sessions.find((s: any) => s.track === trackIndex);
                    return session ? renderSession(session, trackIndex, slot.isRoomRow) : null;
                  })}
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>

          {/* Day 2 */}
          <div ref={day2Ref} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${day2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h2 className="text-4xl font-bold mb-8 !text-[hsl(42,82%,41%)] !italic md:text-5xl">
              Sunday, March 15th
            </h2>

            <div className="overflow-x-auto rounded-lg shadow-2xl">
              <table className="w-full border-collapse min-w-[800px]">
                <thead>
                  <tr className="bg-emerald-800/50">
                    <th className="p-4 text-center font-bold text-foreground border border-white/20 w-40">
                      Time
                    </th>
                    {tracks.map((track, i) => <th key={i} className="p-4 text-center font-bold text-foreground border border-white/20">
                        {track.split("\n").map((line: string, lineIndex: number) => <div key={lineIndex} className={lineIndex > 0 ? "text-xs mt-1 text-red-300 font-normal" : ""}>
                            {line}
                          </div>)}
                      </th>)}
                  </tr>
                </thead>
                <tbody>
                  {day2Schedule.map((slot, i) => <tr key={i} className="hover:bg-white/5 transition-colors">
                      <td className="p-4 font-semibold text-foreground border border-white/10 whitespace-nowrap text-center">
                        {slot.time}
                      </td>
                      {slot.sessions.length === 1 && slot.sessions[0].colspan ? renderSession(slot.sessions[0], 0, slot.isRoomRow) : tracks.map((_, trackIndex) => {
                    const session = slot.sessions.find((s: any) => s.track === trackIndex);
                    return session ? renderSession(session, trackIndex, slot.isRoomRow) : null;
                  })}
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>

          {/* Legend */}
          <div className="mt-12 p-6 bg-slate-800/30 rounded-lg">
            <h3 className="text-xl font-bold text-foreground mb-4">Legend</h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-gradient-to-r from-emerald-600/30 to-teal-600/30 border border-white/10"></div>
                <span className="text-foreground">Keynote</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-blue-600/20 border border-white/10"></div>
                <span className="text-foreground">Workshop</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-emerald-700/30 border border-white/10"></div>
                <span className="text-foreground">Featured Speaker</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-slate-700/20 border border-white/10"></div>
                <span className="text-foreground">Breakout Session</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-amber-600/20 border border-white/10"></div>
                <span className="text-foreground">Break/Lunch</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-pink-600/20 border border-white/10"></div>
                <span className="text-foreground">Reception</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}